import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import SideBar from '../../component/sidebar/SideBar';
import { apilink } from '../../data/fdata';
import './Policy.css';
const DataPolicy = () => {
  const his = useHistory();
  const hecord_tokon = Cookies.get('_hecord_access_user_tokon_');
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  useEffect(async () => {
    const res = await axios.get(`${apilink}/auth/isVerify`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (!res.data.success) {
      his.push('/');
    }
  }, []);
  return (
    <>
      <div className="whole__page">
        <div className="left_side_navbar">
          <SideBar />
        </div>
        <div className="main_div ">
          <div className="main_inner_div">
            <div className="blank_page">
              <div className="container">
                <div className="row">
                  <div className="col-md-8 col-12 mx-auto">
                    <h1>Data Policy page Work in progress</h1>
                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => his.goBack()}
                    >
                      Go Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DataPolicy;
